import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import AppErrorBoundary from '../AppErrorBoundary';
import AppFooter from '../AppLayout/components/AppFooter';
import AppSuspense from '../AppSuspense';
import AppContentViewWrapper from './AppContentViewWrapper';

const ModifiedAppContentView = ({ sxStyle, routes }) => {
  return (
    <AppContentViewWrapper>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          ...sxStyle,
        }}
        className='app-content'
      >
        <AppSuspense>
          <AppErrorBoundary>{routes}</AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </AppContentViewWrapper>
  );
};

export default ModifiedAppContentView;

ModifiedAppContentView.propTypes = {
  sxStyle: PropTypes.object,
  children: PropTypes.node,
  routes: PropTypes.any.isRequired,
};
